module.exports = __webpack_public_path__ + "static/media/G1-34-Machado da Aurora-cod69.2ad7499c.png";